(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-pdp-product-recommendations"]) return;
  try {
    
  class NewPdpRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('new-pdp-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.product-recommendations__item')) {
              this.classList.add('product-recommendations--loaded');
            }

            let carouselSection = this.querySelector('.product-grid');
            // Near-instant snap under prefers-reduced-motion (no slide glide).
            const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            let flkty = new Flickity(carouselSection, {
                watchCSS: true,
                cellAlign: 'left',
                contain: true,
                pageDots: false,
                // match the features carousel: advance by the visible set
                // (one card at a time on mobile), not two fixed cells
                groupCells: true,
                // header arrows instead of Flickity's default side buttons
                prevNextButtons: false,
                // same snappier physics as the features carousel — the
                // defaults read as lag on arrow clicks
                selectedAttraction: reduceMotion ? 1 : 0.12,
                friction: reduceMotion ? 1 : 0.6
            })

            const prevButton = this.querySelector('[data-carousel-prev]');
            const nextButton = this.querySelector('[data-carousel-next]');
            const nav = this.querySelector('.new-pdp-recommendations__nav');
            if (prevButton && nextButton) {
                prevButton.addEventListener('click', () => flkty.previous());
                nextButton.addEventListener('click', () => flkty.next());

                const updateNav = () => {
                    // With every card visible, Flickity still builds slide
                    // groups but `contain` clamps them all to one scroll
                    // target — nothing to navigate, hide the arrows entirely.
                    const canScroll = flkty.slides.length > 1 &&
                        flkty.slides[flkty.slides.length - 1].target !== flkty.slides[0].target;
                    if (nav) nav.classList.toggle('hidden', !canScroll);
                    prevButton.disabled = !canScroll || flkty.selectedIndex === 0;
                    nextButton.disabled = !canScroll || flkty.selectedIndex >= flkty.slides.length - 1;
                };
                flkty.on('select', updateNav);
                this.updateNav = updateNav;
                updateNav();
            }

            // Flickity marks off-screen cells aria-hidden but leaves the
            // card links (title, Shop Now) inside them tabbable — keyboard
            // focus lands in hidden content and the browser's
            // scroll-into-view desyncs the carousel. Mirror the aria-hidden
            // state onto tabindex.
            const syncCellFocus = () => {
                flkty.getCellElements().forEach((cell) => {
                    const hidden = flkty.isActive && cell.getAttribute('aria-hidden') === 'true';
                    cell.querySelectorAll(
                        'a[href], button:not([disabled]), input, select, textarea, [tabindex]'
                    ).forEach((el) => {
                        if (hidden) {
                            if (!('carouselTabindex' in el.dataset)) {
                                el.dataset.carouselTabindex = el.getAttribute('tabindex') || '';
                            }
                            el.setAttribute('tabindex', '-1');
                        } else if ('carouselTabindex' in el.dataset) {
                            if (el.dataset.carouselTabindex) {
                                el.setAttribute('tabindex', el.dataset.carouselTabindex);
                            } else {
                                el.removeAttribute('tabindex');
                            }
                            delete el.dataset.carouselTabindex;
                        }
                    });
                });
            };
            flkty.on('select', syncCellFocus);
            syncCellFocus();

            // Mobile swipe indicator: the 55px segment tracks Flickity's
            // scroll progress along the 2px line; hidden when everything
            // already fits (nothing to swipe).
            const scrubber = this.querySelector('.new-pdp-carousel-scrubber');
            const scrubberBar = scrubber ? scrubber.querySelector('.new-pdp-carousel-scrubber__bar') : null;
            let lastProgress = 0;
            const updateScrubber = (progress) => {
                if (!scrubber || !scrubberBar) return;
                lastProgress = Math.min(Math.max(progress || 0, 0), 1);
                const canScroll = flkty.slides.length > 1 &&
                    flkty.slides[flkty.slides.length - 1].target !== flkty.slides[0].target;
                scrubber.classList.toggle('hidden', !canScroll);
                if (!canScroll) return;
                scrubberBar.style.transform =
                    `translateX(${lastProgress * (scrubber.clientWidth - scrubberBar.offsetWidth)}px)`;
            };
            flkty.on('scroll', updateScrubber);
            updateScrubber(0);

            window.dispatchEvent(new Event('resize'))

            window.addEventListener('resize', () => {
                carouselSection.classList.add('resizing')
                requestAnimationFrame(() => {
                    flkty.resize()
                    carouselSection.classList.remove('resizing')
                    if (this.updateNav) this.updateNav()
                    updateScrubber(lastProgress)
                })
            })
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('new-pdp-recommendations', NewPdpRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.product-recommendations__item')) {
              this.classList.add('product-recommendations--loaded');
            }

            let carouselSection = this.querySelector('.product-grid');
            let flkty = new Flickity(carouselSection, {
                watchCSS: true,
                cellAlign: 'left',
                pageDots: false,
                groupCells: 2
            })
            window.dispatchEvent(new Event('resize'))

            window.addEventListener('resize', () => {
                carouselSection.classList.add('resizing')
                requestAnimationFrame(() => {
                    flkty.resize()
                    carouselSection.classList.remove('resizing')
                })
            })
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
